import "./Container.scss";

interface ContainerProps {
  title?: string;
  style?: any;
  blockStyle?: boolean;
  children?: any;
  darkTheme?: boolean;
  pagesNo?: number;
  currentPage?: number;
  onChangePage?: (idx: number) => void;
}

const Container = (props: ContainerProps) => {
  const title = props.title ? props.title : "";

  return (
    <div
      className={"unit-container" + (props.darkTheme ? " dark" : "")}
      style={props.style}
    >
      <div className={"title-bar" + (props.pagesNo ? " slider-ctrl" : "")}>
        <p className="title">{title}</p>
        {props.pagesNo && (
          <div className="dot-container">
            {Array.from({ length: props.pagesNo }, (_, idx) => (
              <div
                key={"title-bar-slider-dot-" + idx}
                className="dot"
                style={{ opacity: props.currentPage === idx ? 1 : 0.5 }}
                onClick={() => {
                  if (props.onChangePage) props.onChangePage(idx);
                }}
              />
            ))}
          </div>
        )}
      </div>
      <div
        className="content"
        style={{ display: props.blockStyle ? "block" : "flex" }}
      >
        {props.children}
      </div>
    </div>
  );
};

export default Container;
